export const DISCLAIMER_COMPONENT_CONFIG = {
  background: '',
  text: '',
};
